function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext, useReducer, useEffect, useRef, createElement, forwardRef, useMemo } from 'react';
import './Card.css';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import whitelistProps from '../../utils/whitelistProps';
import uuid from '../../utils/uuid';
import useWindowWidth from '../../hooks/useWindowWidth';
import { CardSizeContext } from '../CardGrid/CardGrid';
import Button from '../../Buttons/Button/Button';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import AdditionalIntl from '../../I18n/AdditionalIntl/AdditionalIntl';
import en from './locales/Card.en.json';
var whitelist = whitelistProps();
var MESSAGES = normalizeLocaleData(en, '@dm/components.card');
function cardReducer(state, action) {
  switch (action.type) {
    case 'show:button':
      return _objectSpread({}, state, {
        shouldShowButton: action.payload
      });
    case 'toggle':
      return _objectSpread({}, state, {
        expanded: !state.expanded,
        maxHeight: !state.expanded ? 'none' : action.payload
      });
    default:
      return state;
  }
}
function CSSMeasurementInPixels(context, measurement) {
  var contextFontSize = window.getComputedStyle(context).fontSize;
  var testContext = document.createElement('div');
  testContext.style.fontSize = contextFontSize;
  testContext.style.visibility = 'hidden';
  testContext.style.position = 'absolute';
  testContext.style.left = '-9999px';
  var testSpan = document.createElement('span');
  testSpan.style.fontSize = String(measurement);
  document.body.appendChild(testSpan);
  var pixels = parseFloat(window.getComputedStyle(testSpan).fontSize || '16');
  document.body.removeChild(testSpan);
  return pixels;
}

/**
 * @param {Object} props React component props
 * @param {String} props.tag what the tag of the outermost element should be
 * @param {JSX} props.children the content of your card
 * @param {Function} props.button a function that returns a button. Make sure to
 *   spread provided `props` if using this functionality!
 * @param {String} props.className for extending the style of the card wrapper
 */
function Card(_ref) {
  var id = _ref.id,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? 'li' : _ref$tag,
    children = _ref.children,
    button = _ref.button,
    forwardedRef = _ref.forwardedRef,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    attrs = _objectWithoutProperties(_ref, ["id", "tag", "children", "button", "forwardedRef", "className"]);
  var Tag = tag;
  var cardId = useMemo(function () {
    return id ? "card-".concat(id) : "card-".concat(uuid());
  }, [id]);
  var ref = useRef(null);
  var buttonRef = useRef(null);
  var _useContext = useContext(CardSizeContext),
    layout = _useContext.layout,
    baseHeight = _useContext.baseHeight;
  var width = useWindowWidth();
  var isExpandable = !!baseHeight;
  var _useReducer = useReducer(cardReducer, {
      expanded: !isExpandable,
      maxHeight: !isExpandable ? 'none' : baseHeight,
      shouldShowButton: false
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var expanded = state.expanded,
    shouldShowButton = state.shouldShowButton,
    maxHeight = state.maxHeight;
  function handleClick() {
    var current = expanded ? buttonRef.current : ref.current;
    dispatch({
      type: 'toggle',
      payload: baseHeight
    });
    current && current.focus();
  }
  useEffect(function () {
    // if card__wrapper height is equal to maxHeight, then yes we need the
    // expand button, otherwise if card__wrapper height is less than maxHeight,
    // we cool
    var current = ref.current;
    if (current) {
      dispatch({
        type: 'show:button',
        payload: current.scrollHeight >= CSSMeasurementInPixels(current, baseHeight)
      });
    }
  }, [baseHeight, children, layout, width]);
  function renderButton() {
    var buttonProps = {
      ref: buttonRef,
      type: 'button',
      onClick: handleClick,
      'aria-expanded': expanded,
      'aria-owns': cardId
    };
    if (button && typeof button === 'function') {
      return button({
        props: buttonProps,
        expanded: expanded
      });
    } else {
      return /*#__PURE__*/React.createElement(AdditionalIntl, {
        messages: MESSAGES,
        path: "Card/locales/Card",
        namespace: "@dm/components.card"
      }, /*#__PURE__*/React.createElement(Button, Object.assign({
        className: "card__button",
        style: {
          fontSize: 11
        }
      }, buttonProps), /*#__PURE__*/React.createElement(ButtonLabel, {
        i18nKey: "@dm/components.card.".concat(expanded ? 'collapse' : 'expand')
      })));
    }
  }
  return createElement(Tag, {
    className: "card card--".concat(layout),
    ref: forwardedRef
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", Object.assign({
    id: cardId,
    className: "card__wrapper ".concat(className),
    style: {
      maxHeight: maxHeight
    },
    ref: ref,
    tabIndex: -1
  }, whitelist(attrs)), children), shouldShowButton && isExpandable && renderButton()));
}
export default forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Card, Object.assign({}, props, {
    forwardedRef: ref
  }));
});